<template>
  <div class="px-4 py-4 bg-white shadow sm:rounded-md">
    <h2
      class="font-semibold"
      :class="expandable ? 'cursor-pointer' : ''"
      @click="expand"
    >
      {{ info.title }}
      <ChevronDownIcon
        v-if="expandable"
        class="h-5 w-5 inline-block transform transition text-gray-500"
        :class="expanded ? 'rotate-180' : 'rotate-0'"
      />
    </h2>
    <div
      class="mt-4 prose prose-sm"
      :class="expanded ? '' : 'line-clamp-3'"
      ref="body"
      v-html="body"
    ></div>
  </div>
</template>

<script>
import { ChevronDownIcon } from "@heroicons/vue/solid";

export default {
  props: {
    info: Object,
    collapsed: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      expanded: !this.collapsed,
      expandable: false,
    };
  },
  mounted() {
    const {
      scrollHeight,
      scrollWidth,
      clientHeight,
      clientWidth,
    } = this.$refs.body;

    this.expandable = scrollHeight > clientHeight || scrollWidth > clientWidth;
    this.expanded = !this.expandable;
  },
  computed: {
    body() {
      if (this.expanded) return this.info.body;

      const tmp = document.createElement("div");
      tmp.innerHTML = this.info.body;
      const content = tmp.textContent || tmp.innerText || "";
      return content.trim();
    },
  },
  methods: {
    expand() {
      if (this.expandable) {
        this.expanded = !this.expanded;
      }
    },
  },
  components: {
    ChevronDownIcon,
  },
};
</script>
